
import {
  Component,
  Vue
} from 'vue-property-decorator';
import CollapseItem from '@/components/collapse.vue';
import PageFooter from '@/components/page-footer.vue';
import UploadImg from '@/components/upload-img.vue';
import SlzDialog from '@/components/dialog.vue';
import Switch from '@/components/switch.vue';
import {
  getOssToken
} from '@/api/user'
import {
  productCategory,
} from '@/api/supplier'
import {
  productfilterBoxList
} from '@/api/statistic'
import {
  homeNavigationhomeNavigationSave,
  homeNavigationhomeNavigationInfo
}from "@/api/agent_user"
import {imgHost} from "@/utils/config"
import { number } from 'echarts';
@Component({
  name: 'product-detail',
  components: {
    CollapseItem,
    PageFooter,
    UploadImg,
    SlzDialog,
    'slz-switch': Switch,
  }
})
export default class AuthRoles extends Vue {
  private imgurl = imgHost
  private lastSaveTime = ''
  private information:any = {
    CategoryNavigationList:[],
    CategoryNavigationRelaseTime:'',
    ImgNavigationList:[]
  };
  private navigationmsg:any = {
    Name:'',
    Icon:[],
    ProductCategoryId:'',
    CategoryNavigationRelationType:'',
    SystemPageId:''
  }
  private ImgNavigation:any = {
    ImgUrl:[],
    RelationType:null,
    ReltionId:'',
    UpdateTime:'',
    IsDisplay:true,
    AddTime:'',
  }
  private changeindex:any = -1;
  private token:any = {};
  private show = false;
  private ispush = false;
  private shoplist:any = [];
  private imgshow = false
  private relevancelist:any = []
  private classityList:any = []
  private systempages:any = [
    {value:0,label:'申请复团'},
    {value:1,label:'开放式查单'},
  ]
  private typelist:any = [
    {value:0,label:'商品分类'},
    {value:1,label:'系统页面'},
  ]


  private mounted () {
    this.getinfo()
    this.getclassityList()
    this.getshopList()
  }

  private changeRelationType(){
    this.navigationmsg.ProductCategoryId = ''
    this.navigationmsg.SystemPageId = ''
  }
  private async save(){
    try{
      let data = JSON.parse(JSON.stringify(this.information))
      data.CategoryNavigationList = data.CategoryNavigationList.map(v=>{
        v.Icon = v.Icon[0]
        return v
      })

      data.CategoryNavigationRelaseTime = data.CategoryNavigationRelaseTime?data.CategoryNavigationRelaseTime:this.nowtime()

      data.ImgNavigationList = data.ImgNavigationList.map(v=>{
        v.ImgUrl = v.ImgUrl[0]
        return v
      })

      let res = await homeNavigationhomeNavigationSave(data)
      if(res.IsSuccess){
        this.$message.success('保存成功')
        this.getinfo()
      }
    }finally{
      //
    }
  }

  private async getinfo(){
    try{
      let res = await homeNavigationhomeNavigationInfo({})
      if(res.IsSuccess){
        // console.log(res)
        let msg = res.Result
        msg.CategoryNavigationList = msg.CategoryNavigationList.map(v=>{
          v.Icon = [v.Icon]
          return v
        })

        this.lastSaveTime = msg.CategoryNavigationRelaseTime

        msg.ImgNavigationList = msg.ImgNavigationList.map(v=>{
          v.ImgUrl = [v.ImgUrl]
          return v
        })

        this.information = msg
      }
    }finally{
      //
    }
  }

  private closeImg(){
    this.ImgNavigation = {
      ImgUrl:[],
      RelationType:0,
      ReltionId:'',
      UpdateTime:'',
      IsDisplay:true,
      AddTime:'',
    }
    this.changeindex = -1
    this.imgshow = false
  }

  private nowtime(){
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth()+1>10?date.getMonth()+1:'0'+(date.getMonth()+1)
    let day = date.getDate()>10?date.getDate():'0'+date.getDate()
    let hour = date.getHours()>10?date.getHours():'0'+date.getHours()
    let min = date.getMinutes()>10?date.getMinutes():'0'+date.getMinutes()
    let sec = date.getSeconds()>10?date.getSeconds():'0'+date.getSeconds()
    return [year,month,day].join('-')+' '+[hour,min,sec].join(':')
  }

  private confirmImgNavigation(){
    if(!this.ImgNavigation.ImgUrl.length){
      this.$message.error('请上传图标')
      return 
    }
    if(!this.ImgNavigation.UpdateTime){
      this.ImgNavigation.UpdateTime = this.nowtime()
    }
    if(this.changeindex<0){
      this.information.ImgNavigationList.unshift(this.ImgNavigation)
    }else{
      this.information.ImgNavigationList[this.changeindex] = this.ImgNavigation
    }
    this.imgshow = false
  }

  private getrelevance(e){
    this.ImgNavigation.ReltionId = null
    if(e==0){
      this.getclassityList()
    }else{
      this.getshopList()
    }
  }

  private async getshopList(){
    try{
      const res:any = await productfilterBoxList({})
      if(res.IsSuccess){
        this.relevancelist = res.Result
      }
    }finally{
      //
    }
  }


  private showDeleteDialog(index){
    this.information.ImgNavigationList.splice(index,1)
  }

  private toDetail(index){
    this.imgshow = true
    this.changeindex = index
    setTimeout(()=>{
      if(index < 0){
        this.ispush = true
        this.ImgNavigation = {
          ImgUrl:[],
          RelationType:null,
          ReltionId:'',
          UpdateTime:'',
          IsDisplay:true,
          AddTime:'',
        }
        return
      }
      this.ImgNavigation = JSON.parse(JSON.stringify(this.information.ImgNavigationList[index]))
      // console.log(this.ImgNavigation)
      this.ispush = false
    })
  }

  private delnavigation(index){
    this.information.CategoryNavigationList.splice(index,1)
  }

  private pushnavigation(index){
    this.show = true
    // console.log(index)
    setTimeout(()=>{
      this.changeindex = index
      if(index < 0){
        this.ispush = true
        this.navigationmsg = {
          Name:'',
          Icon:[],
          ProductCategoryId:'',
        }
        return
      }
      
      this.ispush = false
      // this.changeindex = index
      console.log(this.changeindex,66)
      this.navigationmsg = JSON.parse(JSON.stringify(this.information.CategoryNavigationList[index]))
    },100)
  }

  
  private confirmnavigation(){
    if(!this.navigationmsg.Name){
      this.$message.error('请输入导航名称')
      return 
    }else if(!this.navigationmsg.Icon.length){
      this.$message.error('请上传图标')
      return 
    }else if(!this.typelist.some(v=>v.value==this.navigationmsg.CategoryNavigationRelationType)){
      this.$message.error('请选择关联类型')
      return 
    }else if(this.navigationmsg.CategoryNavigationRelationType==0&&!this.navigationmsg.ProductCategoryId){
      this.$message.error('请选择关联项')
      return 
    }else if(this.navigationmsg.CategoryNavigationRelationType==1&&!this.typelist.map(v=>v.value).includes(this.navigationmsg.SystemPageId)){
      //这里用some判断 如果为空不会进来
      this.$message.error('请选择关联项')
      return 
    }
    if(this.changeindex<0){
      this.information.CategoryNavigationList.push(this.navigationmsg)
    }else{
      this.information.CategoryNavigationList[this.changeindex] = this.navigationmsg
    }
    this.show = false
  }
  // 商品分类
  private async getclassityList() {
    let params: any = {
      Skip:0,
      Take:99999,
      Keywords:''
    }
    try {
      const res: any = await productCategory(params);
      this.shoplist = res.Result.Results;
      // console.log(this.shoplist.find(v=>v.Id==4))
      
    } catch (err) {
      console.error('getProviderStatistics ===>', err)
    }
  }
  private cancel(){
    this.navigationmsg = {
      Name:'',
      Icon:[],
      ProductCategoryId:'',
    }
    this.changeindex = -1
    this.show = false
  }
  // 获取token
  private async getToken() {
    try {
      const res: any = await getOssToken({})
      this.token = {
        AccessKeySecret: res.access_key_secret,
        OSSAccessKeyId: res.access_key_id,
        SecurityToken: res.security_token
      }
    } catch (e) {
      console.error('getOssToken ===>', e)
    }
  }
  private uploadSuc(e,index){
    // console.log(e)
    if(index==1){
      this.navigationmsg.Icon = e
    }else if(index==2){
      this.ImgNavigation.ImgUrl = e
    }
  }
}
